import Vue from "vue";
import LightBox from 'vue-it-bigger'

Vue.component('light-box', LightBox);

Vue.component("wto-video-viewer", {
	props: ["media"],
	data() {
		return {
			opened: false
		};
	},
	methods: {
		openGallery(index) {
			this.opened = true;
			this.$refs.lightbox.showImage(index);
			this.emitVideoChanged(index);
		},
		emitVideoChanged(index) {
			const lb = this.$refs.lightbox;
			if (lb && lb.lightBoxShown === false) return;
			const item = this.media[index];
			if (item) this.$emit('video-changed', item.videoId);
		},
		onImageChanged(index) {
			this.emitVideoChanged(index);
		},
		onVideoClosed: function(){
			this.$refs.lightbox.nextImage();
			// vue-it-bigger fires onClosed once on mount (show-light-box=false
			// -> mounted() -> onLightBoxClose -> $emit('onClosed')). Only treat
			// it as a real close if the gallery was actually opened, otherwise
			// the mount-time event would strip videoId before deep-link open.
			if (!this.opened) return;
			this.opened = false;
			this.$emit('video-closed');
		}
	},
	template: `
      <div class="columns" style="flex-wrap: wrap">
		  <div class="column is-3" v-for="(image, index) in media" :key="index">
			  <ul style="margin: 0; padding: 0">
				<li	 style="display: inline-block;">
				  <div class="truncate-overflow-1" :title="image.caption">{{ image.caption }}</div>
				  <img :src="image.thumb" style="height: 180px; width:320px; cursor: pointer" @click="openGallery(index)">
				</li>
			  </ul>
		  </div>
          <light-box ref="lightbox" @onClosed="onVideoClosed" @onImageChanged="onImageChanged" :media="media" :show-caption="true" :show-light-box="false"/>
      </div>
	`
});
